import React from 'react';
import ContactMessage from '../atom/ContactMessage';
import ContactButton from '../atom/ContactButton';
import CompanyInfoText from '../atom/CompanyInfoText';
import Ralsnet from '../atom/Ralsnet';
import styles from './Footer.module.scss';

const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <div className={styles.footer__contact}>
      <ContactMessage />
      <ContactButton />
      <CompanyInfoText />
    </div>
    <Ralsnet />
  </footer>
);

export default Footer;
